import "./ErrorFallback.scss";

const ErrorFallback = ({ searchTerm }) => {
  return (
    <main className="error">
      <h1 className="error__header">Oops, something went wrong. 😳</h1>
      <div className="error__container">
        <h2 className="error__sub-header">
          It looks like we couldn't find any data for{" "}
        </h2>
        <span className="error__query">{searchTerm}</span>
      </div>
    </main>
  );
};

export default ErrorFallback;
